import React, { useState, useEffect } from "react";
import '../HomePage/Quotes.css';
import FormDetail from "./FormDetail.jsx";
import EnquiryDetail from "./EnquiryDetail";
import PlansFound from "./PlansFound";
import FormArea from "../HomePage/FormArea";
import axios from 'axios';
import CrossIcon from '../Images/Cross-icon.svg';
import AddonsPOP from "./AddonsPOP";
import Earthquake from "../Images/Earthquake.svg";
import Terrorism from "../Images/terrorism-damage.svg";
import LossOfRent from "../Images/loss-of-rent.svg";
import { apiURL } from "../index";
import { CentralCall } from "../CommonMethods/CentralCall";
import EditDetailCard from "./EditDetailCard";
import { useSharedDataContext } from "../components/SharedDataContext";



const Quotes = ({ location, history }) => {
    const [IsOpenEditForm, setOpenEditForm] = useState(false);
    const [IsOpenAddonspop, setOpenAddonspop] = useState(false);
    const [Quotations, setQuotations] = useState([]);
    const [QuoteReq, setQuoteReq] = useState({});
    const [IsQuoteCall, setIsQuoteCall] = useState(false);
    const [Addons, setAddons] = useState({});
    const [quotePageData, setQuotePageData] = useState({
        policyTerm: "1",
        pincode: "",
        propertyType: "",
        mobileNo: "",
        buildingComponent: {},
        descriptionOfOccupancy: {},
        insurerList: [],
        enquiry:""

    });

    const { sharedData, setSharedData } = useSharedDataContext();

    useEffect(() => {
        if (IsQuoteCall && quotePageData.insurerList.length > 0) {
            Array.isArray(quotePageData.insurerList) && quotePageData.insurerList.forEach(row => getPlan(row.insurerID));
        }
    }, [IsQuoteCall]);

    const getPlan = InsurerID => {
        setQuotations([]);
        const Model = {
            URL: `${apiURL}api/HomeInsurance/GetPlans`,
            Req: { InsurerID },
            IsPost: true
        }
        CentralCall(Model).then(Res => {
                if (Res.data.statusCode === 200) {
                    const plans = Res.data.response;
                    Array.isArray(plans) && plans.forEach(row => {
                        getQutes(row);
                    })
                }
            })
            .catch(err => console.log(err.message))
    }


    const getQutes = (plan) => {
        const QutesReq = {
            "policyTerm": quotePageData.policyTerm,
            "pinCode": quotePageData.pincode,
            "propertyType": quotePageData.propertyType,
            "EnquiryNo": quotePageData.enquiry,
            MobileNo: quotePageData.mobileNo,
            PlanName: plan.planId,
            InsurerID: plan.companyId,
            BuildingComponent: quotePageData.buildingComponent,
            Addons,
            DescriptionOfOccupancy: quotePageData.descriptionOfOccupancy.codeOfOccupation
        }
        setQuoteReq(QutesReq);
        const Model = {
            URL: `${apiURL}api/HomeInsurance/GetQuotes`,
            Req: QutesReq,
            IsPost: true

        }
        CentralCall(Model)
            .then(Res => {
                setIsQuoteCall(false);
                if (Res.data.statusCode === 200) {
                    const qRes = Res.data.response;
                    const FilterRes = qRes.filter(res => res.isSuccess && res.netPremium);
                    qRes.transKey = Res.data.transKey;
                    setQuotations(prvState => [...prvState, ...FilterRes]);
                    setIsQuoteCall(false);
                }
            }).catch(reject => {
                setIsQuoteCall(false);
                console.log(reject)
            });

    }

    useEffect(() => {


        if (sharedData.QuotePageDetails) {
            const quoteData = sharedData.QuotePageDetails;
            setQuotePageData(prev => ({
                ...prev,
                propertyType: quoteData.propertyType,
                insure: quoteData.insure,
                pincode: quoteData.pincode,
                enquiry: quoteData.enquiryRes.enquiryNo,
                mobileNo: quoteData.mobileNo,
                insurerList: quoteData.enquiryRes.insurers,
                buildingComponent: quoteData.buildingComponent,
                descriptionOfOccupancy: quoteData.descriptionOfOccupancy
            }));
            setIsQuoteCall(true);
        }

        /*else window.location.href = "/";*/
    }, []);
    const onSubmitDetails = (data) => {
        setOpenEditForm(false);
        setOpenAddonspop(false);
        setIsQuoteCall(true);

    }
    const buyNow = (data) => {


        const Model = {
            URL: `${apiURL}api/HomeInsurance/SaveQutes`,
            Req: { TransKey: data.transKey, InsurerID: data.insurerID },
            IsPost: true

        }
        CentralCall(Model)
            .then(Res => {
                if (Res.data.isSuccess) {
                    history.push({
                        pathname: "/Proposal",
                        state: {
                            QuoteReq,
                            QuoteRes: data
                        }
                    });
                } else alert("Error in saving");
            });
    }
    return <>
        <div className="HomeQuotationPage">
            <div className="container FormDetail">
                <div className="row">
                    <div className="col-md-12">
                        <FormDetail  setShowForm={(data) => setOpenEditForm(data)}  policyTerm={quotePageData.policyTerm} setPolicyTerm={(e) => { setQuotePageData({ ...quotePageData, policyTerm:e.target.value }); setQuotations([]); setIsQuoteCall(true) }} />
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <EnquiryDetail EnquiryNo={quotePageData.enquiry} plansCount={Quotations.length} />
                        {Array.isArray(Quotations) &&
                            Quotations.map(row => <PlansFound Addons={row.addons ?? []} onAddonsSubmit={data => {
                                setQuotations([]);
                                setAddons(data);
                                setIsQuoteCall(true);
                            }} BuildingComponent={quotePageData.buildingComponent} propertyType={quotePageData.propertyType} pdfURL={row.pdfURL} PlanName={row.planName} sumInsured={row.sumInsured} LogoURL={row.image} Premium={row.netPremium} buyNow={() => buyNow(row)} />
                            )}
                    </div>
                </div>

                <div className="features">
                    <div className="row my-2">
                        <div className="col-md-12">
                            <div className="features2">
                                <h5 className="mb-0">Features included in the above plans</h5>
                                {/*<span><i  class="fa fa-hand-o-down "></i></span>*/}
                            </div>
                        </div>
                    </div>
                    <div className="row mb-5">
                        <div className="col-lg-3 my-2">
                            <div className="features1">
                                <img src={Earthquake} />
                                <p className="mb-0">Earthquake</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="features1 my-2">
                                <img src={Terrorism} />
                                <p className="mb-0">Terrorism Damage Cover Endorsement</p>
                            </div>
                        </div>

                        <div className="col-lg-3">
                            <div className="features1 my-2">
                                <img src={LossOfRent} />
                                <p className="mb-0">Loss of Rent</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {IsOpenEditForm &&
            <div className="HomePageMain FormArea_Editing">
                <div className="col-lg-5 m-auto">
                    <div className="Form_popup">
                        <div className="cross_btn">
                            <button className="" onClick={() => setOpenEditForm(false)}>
                                <img src={CrossIcon} alt="Home Insurance" />
                            </button>
                        </div>
                        <EditDetailCard
                            onSubmitDetails={onSubmitDetails}
                            defaultData={quotePageData}
                            quotePageData={quotePageData }
                            setQuotePageData={data=> setQuotePageData(data) }
                        />
                  </div>
                </div>
            </div>
        }

    </>
}

export default Quotes;